import {
  aCreateTemplatedMatchRule,
  aTemplatedMatchRule,
  mockCreateTemplatedMatchRuleBuilderOperationMutation,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

import { ruleBuilderQuery_match } from '../queries/RuleBuilderQueryOperation.mocks';

export const createTemplatedMatchRuleBuilderOperation = {
  __typename: 'Mutation' as const,
  createTemplatedMatchRule: aCreateTemplatedMatchRule({
    data: {
      ...aTemplatedMatchRule({
        ...ruleBuilderQuery_match.rule,
      }),
    },
  }),
};

export const handlers = [
  mockCreateTemplatedMatchRuleBuilderOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: createTemplatedMatchRuleBuilderOperation,
      });
    }
  ),
];
